{
  "new-softphone": {
    "<0>{values?.firstName}</0> can now access their softphone in the Weave app.": "<0>{values?.firstName}</0> can now access their softphone in the Weave app.",
    "To further customize the use of <1>{values?.deviceName}</1>, you can assign it to Call Groups, Call Queues, and directly route incoming calls to it in<3> Call Routes.</3>": "To further customize the use of <1>{values?.deviceName}</1>, you can assign it to Call Groups, Call Queues, and directly route incoming calls to it in<3> Call Routes.</3>"
  }
}
